import { Stack } from "@mui/material";
import "./styles/HomeView.scss"
import { useEffect, useState } from "react";
import { Avatar, Carousel, Col, ConfigProvider, Progress, Row } from "antd";
import IconoReceta from "../Img/home_view/Recetas.webp"
import ImagenReceta from "../Img/home_view/recetas_mini.webp"
import IconoChat from "../Img/home_view/Chat.webp"
import IconoExpediente from "../Img/home_view/Expedientes.webp"
import IconoSoporte from "../Img/home_view/soporte.webp"
import IconoBlancoYgia from "../Img/logoblancoygia.svg"
import bannerFooter from "../Img/home_view/banner-footer_05.webp";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Content, Footer } from "antd/es/layout/layout";
import { getEstadisticasMedico } from "../services/perfil_services";
import ReactGA from "react-ga4";
import NewNavbar from "../componentes/GeneralComponents/Navbar_Nuevo";
import CardsWhiteHome from "../componentes/homeview/cards_white_home";
import { RightOutlined } from "@ant-design/icons";
import CardsBlueHome from "../componentes/homeview/cards_blue_home";
import { getTokenFirebase } from "../firebase";

function HomeView() {
    const navigate = useNavigate();
    const location = useLocation();

    const data = useSelector((state) => state.userInfo.usuario);

    const [EstadisticasMedico, setEstadisticasMedico] = useState({ pacientes: 0, citas: 0, recetas: 0 });

    async function estadisticasMedico() {
        let response = await getEstadisticasMedico();
        if (response.ok) {
            setEstadisticasMedico({ pacientes: response.data.Pacientes ?? 0, citas: response.data.Citas ?? 0, recetas: response.data.Recetas ?? 0 });
        }
    }

    useEffect(() => {
        ReactGA.send({
            hitType: "pageview",
            page: location.pathname,
            title: location.pathname,
        });
        estadisticasMedico();
        getTokenFirebase();
        return () => {

        }
    }, [])

    return (
        <Stack>
            <NewNavbar
                modulo="Inicio"
                showHomeVieTitle={true}
            />

            <Content
                className="site-layout"
                style={{
                    width: "100%",
                    overflow: "initial",
                    backgroundColor: 'white'
                }}>
                <br />

                <Row className="row-content-home">
                    <Col className="cardsColumns" >
                        <h2 style={{ color: "#3B7DB2" }}>Herramientas</h2>
                        <CardsWhiteHome
                            image={IconoExpediente}
                            title="Expedientes"
                            subtitle="Accede de manera rápida y segura a historiales médicos completos y detallados de tus pacientes."
                            onClick={() => { navigate("/app/Expedientes", { replace: false }); }}
                        />
                        <CardsWhiteHome
                            image={IconoReceta}
                            title="Recetas"
                            subtitle="Prescripciones médicas seguras y válidas, facilitando tratamientos eficientes para mejorar la atención de los pacientes."
                            onClick={() => { navigate("/app/Recetas", { replace: false }); }}
                        />
                        <CardsWhiteHome
                            image={IconoChat}
                            title="Chat"
                            subtitle="Comunícate eficientemente con tus pacientes, enviando y recibiendo imágenes y documentos en cualquier momento."
                            onClick={() => { navigate("/app/chats", { replace: false }); }}
                        />
                        <CardsWhiteHome
                            image={IconoSoporte}
                            title="Soporte Técnico"
                            subtitle="Para cualquier inconveniente, no dudes en contactarnos. Nuestro equipo de soporte está disponible para ayudarte."
                            onClick={() => { navigate("/app/Ayuda", { replace: false, state: { tab: "3" }, }); }}
                        />
                    </Col>
                    <Col className="cardsColumns">
                        <h2 style={{ color: "#3B7DB2" }}>Resumen de tu cuenta</h2>
                        <CardsBlueHome
                            leading={<img src={ImagenReceta} />}
                            title={EstadisticasMedico.recetas > 0 ? (
                                "Genera tus recetas"
                            ) : (
                                "Genera tu primera receta"
                            )}
                            // subtitle="Personaliza tu receta o adjunta el diseño de tu receta."
                            subtitle="Genera tu receta y compartela con tu paciente."
                            onClick={() => { navigate("/app/Recetas", { replace: false }); }}
                        />
                        <CardsBlueHome
                            leading={<Avatar size={70} style={{ backgroundColor: "#3B7DB2", }}><h2 style={{ fontSize: `${EstadisticasMedico.pacientes > 999 ? "1em" : "1.5em"}` }}>{EstadisticasMedico.pacientes}</h2></Avatar>}
                            title="Pacientes"
                            onClick={() => { navigate("/app/Contactos", { replace: false }); }}
                        />
                        <CardsBlueHome
                            leading={<Avatar size={70} style={{ backgroundColor: "#3B7DB2", }}><h2 style={{ fontSize: `${EstadisticasMedico.citas > 999 ? "1em" : "1.5em"}` }}>{EstadisticasMedico.citas}</h2></Avatar>}
                            title="Citas"
                            onClick={() => { navigate("/app/citas", { replace: false }); }}
                        />
                        <CardsBlueHome
                            leading={<Avatar size={70} style={{ backgroundColor: "#3B7DB2", }}><h2 style={{ fontSize: `${EstadisticasMedico.recetas > 999 ? "1em" : "1.5em"}` }}>{EstadisticasMedico.recetas}</h2></Avatar>}
                            title="Recetas"
                            onClick={() => { navigate("/app/Recetas", { replace: false }); }}
                        />
                    </Col>
                </Row>
            </Content>
            <Footer className="footerHome">
                <img className="img-banner-footer" src={bannerFooter} />
                <Row className="row-footer">
                    <img className="img-footer" src={IconoBlancoYgia} />
                </Row>
            </Footer>


        </Stack >
    );
}

export default HomeView;